import React from 'react'
import laserhairredection from "../images/laser hair reduction photo.jpg";
import laserspotremoval from "../images/laser.jpg";
import skincare from "../images/skin care photo.jpg";
import cosmeticsurgery from "../images/Cosmetic Surgery.jpg";
import  tatooremoval from "../images/tatoo removal.jpg";
import lipdarkremoval from "../images/Lip Dark Removal.jpg"
import skindarkremoval from "../images/skindarkremoval.jpg";
import breastimplement from "../images/breast implement.jpg"

function Servicepage() {
  return (
    <div>
           {/* <div className="album py-0">
        <div className="container">
          <h1 style={{color:"#1D4D93"}} ><b>Course Details</b></h1>
          </div>
        </div> */}
      <div className="album py-0">
        <div className="container">
          <div className="row">
           
               <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={laserspotremoval} className="card-img-top" alt="laserspotremoval" />
                <div className="card-body">
                  <h5 style={{color:"#c67d18"}} className="card-title"> Laser Spot Removal</h5>
                                    <p className="card-text"><small>Safe and effective laser treatment to reduce dark spots, pigmentation, and blemishes—revealing clearer, brighter, and even-toned skin.</small></p>
                  <a href="tel: 9239597019" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5"/>
</svg> Call Enquiry</a>
                           
                </div>
              </div>
            </div>
                <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={skincare} className="card-img-top" alt="skincare" />
                <div className="card-body">
                  <h5 style={{color:"#c67d18"}} className="card-title">Skin Care</h5>
                                    <p className="card-text"><small>Professional skin care treatments designed to cleanse, nourish, and rejuvenate your skin—helping you achieve a healthy, glowing, and youthful appearance.</small></p>
                               <a href="tel: 9239597019" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5"/>
</svg> Call Enquiry</a>
                           
                </div>
              </div>
            </div>


              <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={cosmeticsurgery} className="card-img-top" alt="cosmeticsurgery" />
                <div className="card-body">
                  <h5 style={{color:"#c67d18"}} className="card-title">Cosmetic Surgery</h5>
                                    <p className="card-text"><small>Advanced cosmetic procedures to enhance your natural beauty—offering safe, personalized solutions for a more confident and refined appearance.</small></p>
                          <a href="tel: 9239597019" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5"/>
</svg> Call Enquiry</a>
                          
                </div>
              </div>
            </div>


              <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={tatooremoval} className="card-img-top" alt="tatooremoval" />
                <div className="card-body">
                  <h5 style={{color:"#c67d18"}} className="card-title">Tatoo Removal</h5>
                                    <p className="card-text"><small>Advanced laser treatment to safely fade and remove unwanted tattoos—helping restore clear, natural-looking skin with minimal discomfort and downtime.</small></p>
                               <a href="tel: 9239597019" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5"/>
</svg> Call Enquiry</a>
                       
                </div>
              </div>
            </div>


              <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={lipdarkremoval} className="card-img-top" alt="lipdarkremoval" />
                <div className="card-body">
                  <h5 style={{color:"#c67d18"}} className="card-title">Lip Darkening Removal </h5>

                                    <p className="card-text"><small>Effective laser and advanced treatments to reduce lip pigmentation and restore natural pink lips.</small></p>
                                         <a href="tel: 9239597019" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5"/>
</svg> Call Enquiry</a>
                          
                </div>
              </div>


            </div>
            <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={breastimplement} className="card-img-top" alt="breastimplement" />
                <div className="card-body">
                  <h5 style={{color:"#c67d18"}} className="card-title">Breast Implant</h5>
                                    <p className="card-text"><small>Enhance your body contour with safe and advanced breast implant procedures. Designed to improve shape, size, and symmetry—helping you achieve a natural, balanced, and confident look.</small></p>
                                        <a href="tel: 9239597019" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5"/>
</svg> Call Enquiry</a>
                           
                </div>
              </div>
            </div>
             <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={laserhairredection} className="card-img-top" alt="laserhairredection" />
                <div className="card-body">
                  <h5 style={{color:"#c67d18"}} className="card-title">Laser Hair Redection</h5>
                                    <p className="card-text"><small>Achieve smooth, hair-free skin with advanced laser hair reduction treatments. Safe, long-lasting solution for removing unwanted hair from face and body with minimal discomfort and no downtime.</small></p>
                                        <a href="tel: 9239597019" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5"/>
</svg> Call Enquiry</a>
                           
                </div>
              </div>
            </div>

             <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={skindarkremoval} className="card-img-top" alt="skindarkremoval" />
                <div className="card-body">
                  <h5 style={{color:"#c67d18"}} className="card-title">Skin Darkening Removal</h5>
                                    <p className="card-text"><small>Advanced skin brightening treatments to reduce dark patches, pigmentation, and uneven skin tone</small></p>
                                        <a href="tel: 9239597019" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5"/>
</svg> Call Enquiry</a>
                           
                </div>
              </div>
            </div>

             
          </div>
        </div>
      </div>
    </div>
  )
}

export default Servicepage